import { useState, useEffect, useRef } from 'react';

const useIsUserOnTab = (delay: number) => {
	const timerId: any = useRef(null);
	const [isUserOnTab, setIsUserOnTab] = useState(true);
	const [isCheckingForActivity, setIsCheckingForActivity] = useState(true);

	const checkIfTabIsHidden = () =>
		new Promise((resolve) => {
			resolve(document.hidden);
		});

	useEffect(() => {
		if (isCheckingForActivity) {
			clearInterval(timerId);
			timerId.current = setInterval(() => {
				checkIfTabIsHidden().then((status) => {
					setIsUserOnTab(!status as boolean);
				});
			}, delay);
		} else {
			clearInterval(timerId.current);
		}
	}, [isCheckingForActivity, delay]);

	return { isUserOnTab, setIsCheckingForActivity };
};

export default useIsUserOnTab;
